import React from 'react'

// ── Shared SVG props ──────────────────────────────────────────────────────────
const svgProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
}

export interface NavItem {
  key: string
  text: string
  href: string
  icon: React.ReactNode
}

export interface NavSection {
  label: string
  items: NavItem[]
}

export const adminNavigation: NavSection[] = [
  {
    label: 'Workspace',
    items: [
      {
        key: 'overview',
        text: 'Overview',
        href: '/admin',
        icon: <svg {...svgProps}><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
      },
    ],
  },
  {
    label: 'Users',
    items: [
      {
        key: 'users',
        text: 'All Users',
        href: '/admin/users',
        icon: <svg {...svgProps}><circle cx="9" cy="7" r="4"/><path d="M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/><path d="M21 21v-2a4 4 0 0 0-3-3.85"/></svg>,
      },
      {
        key: 'subscriptions',
        text: 'Subscriptions',
        href: '/admin/subscriptions',
        icon: <svg {...svgProps}><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>,
      },
    ],
  },
  {
    label: 'System',
    items: [
      {
        key: 'analytics',
        text: 'Analytics Logs',
        href: '/admin/analytics',
        icon: <svg {...svgProps}><path d="M3 3v18h18"/><path d="m7 14 4-4 3 3 5-6"/></svg>,
      },
      {
        key: 'settings',
        text: 'Settings',
        href: '/admin/settings',
        icon: <svg {...svgProps}><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
      },
    ],
  },
]
